import { ItemAnalyticsModel, ItemListAnalyticsModel } from '@/@types/client-api';
import { AnalyticsEventName, AnalyticsContext } from './constants';
import { trackEvent } from './utils';
import { ConvertItemAnalyticsModelBase, createTransactionId } from './analyticsUtils';
import {
  resolveItemAnalyticsContext,
  trackAddToCart,
  trackBeginCheckoutEvent,
  trackPurchaseEvent
} from './ecommerce';

export const trackMoreLikeThisEvent = (itemAnalyticsModel?: ItemAnalyticsModel) => {
  if (itemAnalyticsModel) {
    trackEvent({
      eventName: AnalyticsEventName.MoreLikeThis,
      parameters: {
        context: AnalyticsContext.Cards,
        items: [ConvertItemAnalyticsModelBase(itemAnalyticsModel)]
      },
    });
  }
};

export const trackCardLaunchAProgramEvent = (
  itemAnalyticsModel?: ItemAnalyticsModel,
  context?: AnalyticsContext,
  isZeroDollar?: boolean,
  itemListAnalyticsModel?: ItemListAnalyticsModel,
  isStoredInstrument?: boolean,
  itemIndex?: number
) => {
  if (itemAnalyticsModel) {
    const resolvedContext = resolveItemAnalyticsContext(
      itemAnalyticsModel,
      itemListAnalyticsModel,
      itemIndex
    );

    if (isZeroDollar) {
      const transactionId = createTransactionId('WEBZERO');
      trackAddToCart(
        itemAnalyticsModel,
        context,
        transactionId,
        resolvedContext.itemListAnalyticsModel,
        resolvedContext.itemIndex
      );
      trackBeginCheckoutEvent(
        itemAnalyticsModel,
        context,
        transactionId,
        resolvedContext.itemListAnalyticsModel,
        resolvedContext.itemIndex
      );
      trackPurchaseEvent(
        itemAnalyticsModel,
        context,
        transactionId,
        resolvedContext.itemListAnalyticsModel,
        isStoredInstrument,
        resolvedContext.itemIndex
      );
      trackZeroPurchaseValueEvent(
        itemAnalyticsModel,
        context,
        resolvedContext.itemListAnalyticsModel,
        resolvedContext.itemIndex
      );
    }

    trackEvent({
      eventName: AnalyticsEventName.LaunchAProgram,
      parameters: {
        context: context || '',
        items: [
          ConvertItemAnalyticsModelBase(
            itemAnalyticsModel,
            resolvedContext.itemListAnalyticsModel,
            resolvedContext.itemIndex
          )
        ]
      },
    });
  }
};

export const trackCardReadNowEvent = (itemAnalyticsModel?: ItemAnalyticsModel) => {
  if (itemAnalyticsModel) {
    trackEvent({
      eventName: AnalyticsEventName.ReadNow,
      parameters: {
        context: AnalyticsContext.Cards,
        items: [ConvertItemAnalyticsModelBase(itemAnalyticsModel)]
      },
    });
  }
};

export const trackCardRequestCreditEvent = (
  itemAnalyticsModel?: ItemAnalyticsModel,
  context?: AnalyticsContext
) => {
  if (itemAnalyticsModel) {
    trackEvent({
      eventName: AnalyticsEventName.RequestCreditStart,
      parameters: {
        context: context || '',
        items: [ConvertItemAnalyticsModelBase(itemAnalyticsModel)]
      },
    });
  }
};

export const trackZeroPurchaseValueEvent = (
  itemAnalyticsModel?: ItemAnalyticsModel,
  context?: AnalyticsContext,
  itemListAnalyticsModel?: ItemListAnalyticsModel,
  itemIndex?: number
) => {
  if (itemAnalyticsModel) {
    const resolvedContext = resolveItemAnalyticsContext(
      itemAnalyticsModel,
      itemListAnalyticsModel,
      itemIndex
    );

    trackEvent({
      eventName: AnalyticsEventName.ZeroPurchaseValue,
      parameters: {
        context: context || '',
        value: itemAnalyticsModel?.listPrice || 0,
        currency: itemAnalyticsModel?.currency || '',
        items: [
          ConvertItemAnalyticsModelBase(
            itemAnalyticsModel,
            resolvedContext.itemListAnalyticsModel,
            resolvedContext.itemIndex
          )
        ],
        purchase_source: 'WithRequest'
      },
    });
  }
};

